// extracted by mini-css-extract-plugin
export default {"linkContainer":"styles_linkContainer__b0yxZ","linkWrapper":"styles_linkWrapper__GuNiW"};